import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\FetchDocumentsDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchDocumentsDossierByIdController.php
* @route '/api/dossier-documents/{dossier}'
*/
const FetchDocumentsDossierByIdController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDocumentsDossierByIdController.url(args, options),
    method: 'get',
})

FetchDocumentsDossierByIdController.definition = {
    methods: ["get","head"],
    url: '/api/dossier-documents/{dossier}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\FetchDocumentsDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchDocumentsDossierByIdController.php
* @route '/api/dossier-documents/{dossier}'
*/
FetchDocumentsDossierByIdController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDocumentsDossierByIdController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\FetchDocumentsDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchDocumentsDossierByIdController.php
* @route '/api/dossier-documents/{dossier}'
*/
FetchDocumentsDossierByIdController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDocumentsDossierByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\FetchDocumentsDossierByIdController::__invoke
* @see app/Http/Controllers/Dossier/FetchDocumentsDossierByIdController.php
* @route '/api/dossier-documents/{dossier}'
*/
FetchDocumentsDossierByIdController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDocumentsDossierByIdController.url(args, options),
    method: 'head',
})

export default FetchDocumentsDossierByIdController